import Vue from 'vue'
import Router from 'vue-router'
import loginPage from '../components/login/loginPage';
import loginUserPage from '../components/login/loginUserPage';
import productPage from '../components/product/productPage';
import postPage from '../components/post/postPage';
import productDetailsPage from '../components/product/productDetailsPage';
import homePage from '../components/home/homePage';
import serverProductPage from '../components/product/serverProductPage';
import serverProductDetailsPage from '../components/product/serverProductDetailsPage';
import productListPage from '../components/product/productListPage';
import productDetailsListPage from '../components/product/productListDetailsPage';


Vue.use(Router);

//获取原型对象上的push函数
const originalPush = Router.prototype.push
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
export default new Router({
  routes: [
    {
      path: "/",
      name: "homePage",
      component: homePage
    },
    {
      path: "/productList",
      name: "productListPage",
      component: productListPage
    },
    {
      path: "/productListDetails",
      name: "productDetailsListPage",
      component: productDetailsListPage
    },
    {
      path: '/login',
      name: 'loginPage',
      component: loginPage
    },
    {
      path: '/loginUser',
      name: 'loginUserPage',
      component: loginUserPage
    },
    {
      path: '/product',
      name: 'productPage',
      component: productPage
    },
    {
      path: '/serverProduct',
      name: 'serverProductPage',
      component: serverProductPage
    },
    {
      path: '/serverProductDetails/:productId',
      name: 'serverProductDetailsPage',
      component: serverProductDetailsPage,
      props: true

    },
    {
      path: '/post',
      name: 'postPage',
      component: postPage
    },
    {
      path: '/productDetails/:productId',
      name: 'productDetailsPage',
      component: productDetailsPage,
      props: true
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    return {x: 0, y: 0}
  }

})



// WEBPACK FOOTER //
// ./src/router/index.js